export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11071.c9b6e8e3.jpg";